import DestinationInfoCards from './DestinationInfoCards';

export default DestinationInfoCards;
